import Vue from 'vue';
/**
 * 用于给input绑定，限定其输入值：
 * 【使用方法】：
 * <ks-input v-model="value" placeholder="placeholder" v-bound="{limit:2}""></ks-input>
 * 【注意】
 * 这里如果非数字就直接干出毛病来了
 * 【参数支持】
 * 其他情况都为不开启（包括undefined）
 * 1、config.limit（小数点精度）:
 * [-1]：不限制
 * [0]：整数
 * [1]：小数点1位
 * [2]：小数点2位
 * ...以此类推
 * 
 * 2、config.range
 * [0,100]
 * 接受数组，第一位是最小值，第二位是最大值
 * 如果数组的key不是数字，则不进行校验
 * 
 */
const trigger = (el, type) => {
    const e = document.createEvent('HTMLEvents')
    e.initEvent(type, true, true)
    el.dispatchEvent(e)
}
export default Vue.directive('bound', {
    bind(el, binding) {
        if (!binding.value) {
            binding.value = {};
        }
        /**
         *
         * 在最后blur的时候，直接变成规定位数的取整数
         * 
         */
        // 确定input
        let input;
        if (el.tagName === 'INPUT') {
            input = el;
        }
        else {
            input = el.getElementsByTagName('input')[0]
        }
        if (!input) {
            console.error('[v-bound] error:', el, '元素内部不存在input，无法使用该指令');
            return false;
        }

        // 检查潜在问题
        var type = input.getAttribute('type');
        if (type !== 'number') {
            try {
                throw new Error('[v-bound] warining:' + input +  '指令内部的input元素非type=number类型，非数字类型存在计算问题，请注意。');
            } catch (err) { }
        }
        if (binding.value.limit < 0) {
            try {
                console.error('limit不能小于0');
            } catch (err) { }
        }
        // 逻辑
        input.onkeyup = function (e) {
            // // 1、屏蔽不合规字符输入
            // 暂时不让输入-和e，即便是number类型
            input.value = input.value.replace(/[\-e]/g, '');
            // // 开头不让以点为开始（防止识别问题）
            input.value = input.value.replace(/^\./, '');
            // 开头不以0开始
            input.value = input.value.replace(/^0(?=\d+)/, '');

            // // 如果有位数限制，就在匹配到的时候直接给多余位干掉
            if (Object.prototype.toString.call(binding.value.limit) === '[object Number]') {
                if (binding.value.limit > 0) {
                    // 去除多余小数点
                    var limit = new RegExp(`(?<=\\d+\\.\\d{${binding.value.limit}})(\\d*)`);
                    // 限制输入位数
                    input.value = input.value.replace(limit, '');
                }
                else if (binding.value.limit === 0) {
                    input.value = input.value.replace(new RegExp("(?<=\d+)(\.[\.\d]?)"), '');
                }
            }
            else {
                input.value = input.value.replace(new RegExp("(?<=\.{1})((\.+\d*)*)"), '');
            }
            
            // 做一下range，超出了自动变最大或者最小
            if (Object.prototype.toString.call(binding.value.range) === '[object Array]') {
                if (Object.prototype.toString.call(binding.value.range[0]) === '[object Number]') {
                    if (input.value < binding.value.range[0]) {
                        input.value = binding.value.range[0];
                    }
                }
                if (Object.prototype.toString.call(binding.value.range[1]) === '[object Number]') {
                    if (input.value > binding.value.range[1]) {
                        input.value = binding.value.range[1];
                    }
                }
            }
            // 目前看如果不设置一个异步，就会导致在这个tick抢占输入内容导致有错误
            var timeout = setTimeout(()=>{
                trigger(input, 'input');
                clearTimeout(timeout);
            },10)
        }
    },
});
